<tab-container>
    <ng-template tab-pane [canDeactivate]="canDeactivate()" title="Structure" >
        <structure></structure>
    </ng-template>
    <ng-template tab-pane [canDeactivate]="canDeactivate()" title="Natural Occurrence Descriptor" [hasData]="_stateMap.hasMaterialDataFor('natural-occurrences')" >
        <natural-occurrences [materialId]="material.materialId"></natural-occurrences>
    </ng-template>
</tab-container>
